/**
 * Helper functions for converting between different time units.
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

/**
 * Convert seconds to milliseconds
 * @param seconds time in seconds
 * @returns time in milliseconds
 */
export function toMs(seconds: number): number {
    return seconds * 1000
}
